const styles = {
    typographyBody: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "1.5",
        letterSpacing: "0.15px",
        padding: "10px 0px",
    },
    boxPaddingBottom: {
        padding: "20px 0px 10px 0px",
    },
    formControlStyle: {
        "& .MuiFormControl-root": {
            paddingRight: "0px",
        },
    },
};

export default styles;
